<template>
	<Card>
		<template #content>
			<div class="flex flex-col gap-8">
				<FormGroup :label="$t('forms.permission.permission_properties_form.name')" :error-text="form.errors?.name">
					<InputText
							ref="name"
							v-model="form.name"
							:disabled="true"
					/>
				</FormGroup>
				<FormGroup :label="$t('forms.permission.permission_properties_form.display_name')" :error-text="form.errors?.display_name">
					<InputText
							ref="display_name"
							v-model="form.display_name"
							@change="form.validate('display_name')"
							@keyup="onDisplayNameChange"
					/>
				</FormGroup>
				<FormGroup :label="$t('forms.permission.permission_properties_form.description')" :error-text="form.errors?.description">
				<Textarea
						ref="description"
						v-model="form.description"
						@change="form.validate('description')"
						rows="5"
				/>
				</FormGroup>
			</div>
		</template>

		<template v-if="hasOnSaveListener || hasOnDeleteListener" #footer>
			<div class="flex justify-end space-x-3">
				<Button class="px-8" severity="danger" text v-if="hasOnDeleteListener && form.id" @click="$emit('on-delete', form)"
				        :label="$t('forms.common.delete')"
				        :disabled="true"/>
				<Button class="px-8" v-if="hasOnSaveListener" @click="$emit('on-save', form)" :label="$t('forms.common.save')"
				        :disabled="true"/>
			</div>
              <p class="text-sm text-gray-500 mt-2 text-right">
                Note: Editing permissions has been disabled for data integrity and testing reasons.<br />If you need to change a permission, please contact a developer.
              </p>
		</template>
	</Card>
</template>

<script>
import FormGroup from "@/Components/FormGroup.vue";

export default {
	name: "PermissionPropertiesForm",
	components: {FormGroup},
	props: {
		form: {
			type: Object,
			required: true,
		},
	},
	computed: {
		hasOnSaveListener() {
			return !!(this.$attrs?.onOnSave);
		},
		hasOnDeleteListener() {
			return !!(this.$attrs?.onOnDelete);
		},
	},
	mounted() {
		this.$refs.name.$el.focus();
	},
	methods: {
		onDisplayNameChange($event) {
			this.form.name = this.form.display_name?.replace(' ', ':').replaceAll(' ', '-').toLowerCase();
			this.form.validate('name');
		}
	},
}
</script>

<style scoped>

</style>